import { z } from "zod";
/**
 * Platform admin allowlist entry, stored at `/admins/{email}` where the
 * document id is the lowercased email. Managed manually in the Firestore
 * console; the admin panel only reads this collection.
 */
export const AdminSchema = z.object({
    email: z.string().email(),
    /** Free-text note on who this admin is / why they were added. */
    note: z.string().nullable().optional(),
    createdAt: z.string().datetime().optional(),
});
/**
 * AI usage log, stored at `/aiUsageLogs/{logId}` — written exclusively by
 * Cloud Functions (admin SDK), read-only in the admin panel.
 *
 * No producer exists yet, so the exact shape is not pinned down: every field
 * is optional and unknown keys are preserved (`passthrough`). The viewer must
 * render defensively.
 */
export const AiUsageLogSchema = z
    .object({
    weddingId: z.string().optional(),
    userId: z.string().optional(),
    feature: z.string().optional(),
    model: z.string().optional(),
    tokensIn: z.number().optional(),
    tokensOut: z.number().optional(),
    createdAt: z.string().datetime().optional(),
})
    .passthrough();
